import React, { Fragment } from 'react';

const NotificationsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Vertical Section Marker tracks where the user is on a page.
          </h1>
        </div>
        <div className="right">
          <p>The Vertical Section Marker works as a normal menu or side nav, where there is a list of clickable menus that will lead the user to a specific location in a page, but with an extra feature: when the user scrolls to a new section in the page, the respective menu will be automatically selected.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Standard</h2>
          <p>The standard vertical section marker looks similar to a side nav, but as said above, it’s behavior has a slight variation.</p>
          <h2 className="h2 page-subtitle">Landing Pages</h2>
          <p>This version of the vertical section markers works the same way, but it uses a vertical carousel to inform the user what section he is seeing on that specific moment.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default NotificationsUsage;



// WEBPACK FOOTER //
// ./src/containers/components/VerticalSectionMarker/VerticalSectionMarkerUsage.js